export default "__VITE_PUBLIC_ASSET__57fc130f__"